import React, { useState } from "react";

function Test() {
  const [show, setShow] = useState(false);
  return (
    <div>
      <input type={show ? "text" : "password"} />
      <button onClick={() => setShow(!show)}>Toggle</button>
      <input type={show ? 'text' : 'password'} />
    </div>
  );
}
export default Test;